export default {
  SET_DOWNLOADER(state, payload) {
    state.downloaders = payload;
  },
  GET_DOWNLOADER(state, payload) {
    state.getdownloaders = payload;
  },
  
};
